// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { _ } from "~/i18n";

/**
 * @class HotelClass
 * @augments Content
 * @private
 */
 export default class HotelClass extends Content {
	_build() {
		this._dom.container.classList.add("content-hotelclass");

		// trida hotelu
		this._dom.container.appendChild(Mapy.Util.node("strong", { textContent: _("detail.content.booking.class") + ":" }));
		this._dom.container.appendChild(document.createTextNode(this._data + "-" + _("detail.content.booking.classStar")));
	}
};
